import { createContext, useContext } from "react";

const DialogPortalContainerContext = createContext<HTMLElement | null>(null);

const useDialogPortalContainer = () => useContext(DialogPortalContainerContext);

export { DialogPortalContainerContext, useDialogPortalContainer };
